// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
//主组件
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//vue路由
import router from './router';
//vuex配置文件
import store from './config/store';
//导入iview的js文件
import iView from 'iview'
//导入iview的css文件
import 'iview/dist/styles/iview.css'

Vue.use(iView)

import filter from './config/filter'

Vue.use(filter)

//后台传输加密
import JsEncrypt from 'jsencrypt'
Vue.prototype.$jsEncrypt = JsEncrypt


Vue.prototype.toHref = function (path) {
    this.$router.push(path);
}
// 修改对象key
Vue.prototype.alterKey = function (obj, beforeKeyName = "personal", newKeyName = "companyManage") {
    var newObj = Object.keys(obj).reduce((newData, key) => {
        if (key.indexOf(beforeKeyName) != -1) {
            var reg = new RegExp(beforeKeyName);
            var newKey = key.replace(reg, "");
            newKey = newKeyName + newKey;
            newData[newKey] = obj[key];
        } else {
            newData[key] = obj[key];
        }
        return newData
    }, {})
    return newObj
}

Vue.prototype.stopScrollFun = function (evt) {
    evt = evt || window.event;
    if (evt.preventDefault) {
        // Firefox
        evt.preventDefault();
        evt.stopPropagation();
    } else {
        // IE
        evt.cancelBubble = true;
        evt.returnValue = false;
    }
    return false;
}
// 去除文字和小数点
Vue.prototype.clearNoNum = function (val, isDecimal) {
    // isDecimal true代表是有小数点的
    let newValue = "";
    if (isDecimal) {
        newValue = val.replace(/[^\d.]/g, "").replace(/^\./g, ''); //清除“数字”和“.”以外的字符 且第一个不能为小数点
    } else {
        newValue = val.replace(/[^\d]/g, ""); //清除“数字”以外的字符
    }
    newValue = newValue.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
    newValue = newValue
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
    newValue = newValue.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
    if (newValue.indexOf(".") < 0 && newValue != "") {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        newValue = parseFloat(newValue);
    }
    return newValue;
}
Vue.config.productionTip = false;

//浏览器关闭事件
// window.addEventListener('unload', logData, false);
// function logData() {
//     var URL = window.baseURL+'/login/exitLogin';
//     var data = 'state=' + state + '&location=' + window.location;
//     navigator.sendBeacon(URL, data)
// }

/* eslint-disable no-new */
window.$vm = new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
});



// WEBPACK FOOTER //
// ./src/main.js